import $axios from 'axios'
import * as url from '../config/uri'
function REQUEST_DATA(reqName, data, reqType = 'json') {
    if (reqType == 'json') {
        return $axios.post(url[reqName], data)
    } else if (reqType == 'file') {
        let params = new FormData()
        params.append('file', data.file)
        params.append('type', data.type)
        return $axios({
            method: 'post',
            url: url[reqName],
            data: params,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }
}
export default REQUEST_DATA